<template>
  <div class="home">
    <h1>{{ msg }}</h1>
    <router-link to="/login">{{ auth.authenticated()?'logout':'login' }}</router-link >
    <router-link to="/projects">projects</router-link >
    <router-link to="/create">create project</router-link>
  </div>
</template>

<script>
import authService from '../auth'

export default {
  name: 'home',
  data () {
    return {
      auth: authService,
      msg: 'Welcome to xInc!'
    }
  }
}
</script>

<style scoped>
.home {
  text-align: center;
}
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// Home.vue?5ab3ecfa